import { z } from 'zod';
import { strictRemoteCodec } from "./remote-codec.js";
import { TurnSelectionSchema } from "./turn-selection.js";
import { RequestedModelsSchema } from "./turn-request-models.js";
import { AutoAllocationSummarySchema } from "./auto-allocation-evidence.js";
export { TurnSelectionSchema } from "./turn-selection.js";
const contribution = {
    package: 'dsh-github-copilot',
    descriptors: [{
            id: 'dsh-github-copilot:githubCopilotTurnSelection.get',
            namespace: 'githubCopilotTurnSelection', service: 'githubCopilotTurnSelection', method: 'get',
            // The footer always supplies the viewed Session ID, even inside a bound Chat.
            invocation: { kind: 'direct' },
            parameters: [
                { name: 'agent', wire: 'agentId', source: 'lookup', lookup: 'agent',
                    codec: strictRemoteCodec('@deepseek-ai/dsh-session/types#SessionId', z.string().min(1).max(256)) },
                { name: 'turn', wire: 'turn', source: 'json',
                    codec: strictRemoteCodec('dsh-github-copilot#TurnSelectionTurn', z.number().int().nonnegative().max(Number.MAX_SAFE_INTEGER)) },
            ],
            result: strictRemoteCodec('dsh-github-copilot#TurnSelection', TurnSelectionSchema),
        }, {
            id: 'dsh-github-copilot:githubCopilotTurnSelection.requestedModels',
            namespace: 'githubCopilotTurnSelection', service: 'githubCopilotTurnSelection', method: 'requestedModels',
            invocation: { kind: 'direct' },
            parameters: [
                { name: 'agent', wire: 'agentId', source: 'lookup', lookup: 'agent',
                    codec: strictRemoteCodec('@deepseek-ai/dsh-session/types#SessionId', z.string().min(1).max(256)) },
                { name: 'turn', wire: 'turn', source: 'json',
                    codec: strictRemoteCodec('dsh-github-copilot#TurnSelectionTurn', z.number().int().nonnegative().max(Number.MAX_SAFE_INTEGER)) },
            ],
            result: strictRemoteCodec('dsh-github-copilot#RequestedModels', RequestedModelsSchema),
        }, {
            id: 'dsh-github-copilot:githubCopilotTurnSelection.allocationSummary',
            namespace: 'githubCopilotTurnSelection', service: 'githubCopilotTurnSelection', method: 'allocationSummary',
            invocation: { kind: 'direct' },
            parameters: [{
                    name: 'agent', wire: 'agentId', source: 'lookup', lookup: 'agent',
                    codec: strictRemoteCodec('@deepseek-ai/dsh-session/types#SessionId', z.string().min(1).max(256)),
                }],
            result: strictRemoteCodec('dsh-github-copilot#AutoAllocationSummary', AutoAllocationSummarySchema),
        }],
};
export default contribution;
//# sourceMappingURL=turn-selection-remote.js.map